import {
  and,
  collection,
  getDocs,
  or,
  query,
  QueryFilterConstraint,
  where,
} from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import UserDoc from '../../models/UserDoc';
import { UserRole } from '@leedpulse-monorepo/enums';

async function searchUsers(
  searchQuery: string,
  roleConstraint?: UserRole
): Promise<UserDoc[]> {
  try {
    const users: UserDoc[] = [];
    const db = firestore;

    const sanitizedSearchQuery = searchQuery.trim();

    const queryConstraints: QueryFilterConstraint[] = [
      or(
        where('email', '==', sanitizedSearchQuery),
        where('email_authentication', '==', sanitizedSearchQuery),
        where('firstname', '==', sanitizedSearchQuery),
        where('lastname', '==', sanitizedSearchQuery)
      ),
    ];

    if (roleConstraint) {
      queryConstraints.push(where('role', '==', roleConstraint));
    }

    const searchResults = await getDocs(
      query(
        collection(db, FirestoreCollections.users),
        and(...queryConstraints)
      )
    );

    searchResults.docs.forEach((doc) => {
      users.push(UserDoc.fromFirestore(doc));
    });

    return users;
  } catch (e) {
    console.error('error: ', e);
    throw new SearchUsersFailure();
  }
}

export class SearchUsersFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default searchUsers;
